import apiClient from '@/services/axios'

// ─── Fuel ──────────────────────────────────────────────────────────────────

export const listFuelEntries = (params) =>
  apiClient.get('/maintenance/fuel', { params })

/** All facility tanks for the org (depot + asset name); not filtered by depot. */
export const getFuelTankOptions = () =>
  apiClient.get('/maintenance/fuel/tanks')

export const createFuelEntry = (data) =>
  apiClient.post('/maintenance/fuel', data)

export const bulkImportFuel = (entries) =>
  apiClient.post('/maintenance/fuel/bulk', { entries })

export const importFuelCsv = (formData) =>
  apiClient.post('/maintenance/fuel/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const getFuelEntry = (id) =>
  apiClient.get(`/maintenance/fuel/${id}`)

export const updateFuelEntry = (id, data) =>
  apiClient.put(`/maintenance/fuel/${id}`, data)

export const deleteFuelEntry = (id) =>
  apiClient.delete(`/maintenance/fuel/${id}`)

// ─── Fuel Receipt Upload ──────────────────────────────────────────────────
export const presignFuelReceipt = (contentType) =>
  apiClient.post('/maintenance/fuel/receipt/presign', { contentType })

export const commitFuelReceipt = (key) =>
  apiClient.post('/maintenance/fuel/receipt/commit', { key })

export async function uploadFuelReceipt(file) {
  const { data: presignRes } = await presignFuelReceipt(file.type)
  const { url, key } = presignRes

  const putRes = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!putRes.ok) throw new Error('S3 upload failed')

  const { data: commitRes } = await commitFuelReceipt(key)
  return commitRes.url
}

// ─── DVIR ──────────────────────────────────────────────────────────────────

export const listDvirEntries = (params) =>
  apiClient.get('/maintenance/dvir', { params })

export const listDvirDefectTypes = () =>
  apiClient.get('/maintenance/dvir/defect-types')

export const createDvirEntry = (data) =>
  apiClient.post('/maintenance/dvir', data)

export const bulkImportDvir = (entries) =>
  apiClient.post('/maintenance/dvir/bulk', { entries })

export const importDvirCsv = (formData) =>
  apiClient.post('/maintenance/dvir/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const getDvirEntry = (id) =>
  apiClient.get(`/maintenance/dvir/${id}`)

export const updateDvirEntry = (id, data) =>
  apiClient.put(`/maintenance/dvir/${id}`, data)

export const deleteDvirEntry = (id) =>
  apiClient.delete(`/maintenance/dvir/${id}`)

// ─── Services (Work Orders) ───────────────────────────────────────────────

export const listServiceWorkOrders = (params) =>
  apiClient.get('/maintenance/services', { params })

export const getServiceWorkOrder = (id) =>
  apiClient.get(`/maintenance/services/${id}`)

export const createServiceWorkOrder = (data) =>
  apiClient.post('/maintenance/services', data)

export const updateServiceWorkOrder = (id, data) =>
  apiClient.put(`/maintenance/services/${id}`, data)

export const deleteServiceWorkOrder = (id) =>
  apiClient.delete(`/maintenance/services/${id}`)

/** Internal location options: org facilities with WO record counts. */
export const listServiceFacilityCounts = () =>
  apiClient.get('/maintenance/services/locations/facilities')

/** External location options for a given vendor (with WO record counts). */
export const listServiceVendorLocations = (vendorId) =>
  apiClient.get(`/maintenance/services/locations/vendor/${vendorId}`)

// ─── Stats ─────────────────────────────────────────────────────────────────

export const getMaintenanceStats = (period) =>
  apiClient.get('/maintenance/stats', { params: { period } })
